<template>
  <div
    style="text-align: right;"
  >
    <el-dropdown
      ref="dropDown"
      size="small"
      @command="handleAction"
    >
      <el-button
        size="mini"
        class="el-dropdown-link"
        @click.stop="toggleDropDown"
      >
        <i :class="!buttonLoader ? 'el-icon-more' : 'el-icon-loading'" />
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-can="'supplierorder.create'"
          :command="copySupplierReturnOrder"
          :disabled="buttonLoader"
        >
          <i class="el-icon-document-copy" /> Másolás
        </el-dropdown-item>
        <el-dropdown-item
          v-if="supplierReturnOrder.status === 'recorded'"
          v-can="'supplierreturnorder.update'"
          :command="send"
          :disabled="buttonLoader"
        >
          <i class="el-icon-s-promotion" /> Termékek visszaküldése
        </el-dropdown-item>
        <el-dropdown-item
          v-can="'supplierreturnorder.update'"
          :command="updateSupplierReturnOrder"
          :disabled="buttonLoader"
        >
          <i class="el-icon-edit" /> Módosítás
        </el-dropdown-item>
        <el-dropdown-item
          v-if="supplierReturnOrder.status === 'recorded'"
          v-can="'supplierreturnorder.delete'"
          :command="openDeleteConfirmation"
          :disabled="buttonLoader"
        >
          <i class="el-icon-delete" /> Törlés
        </el-dropdown-item>
        <el-dropdown-item
          :command="exportExcel"
          :disabled="buttonLoader"
        >
          <i class="el-icon-download" /> Excel exportálás
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
  export default {
    props: ['supplierReturnOrder'],
    data() {
      return {
        buttonLoader: false,
        deleteConfirmVisible: false,
      };
    },

    methods: {
      async deleteSupplierReturnOrder() {
        this.buttonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('supplierReturnOrder/delete', this.supplierReturnOrder.id);
          this.$store.dispatch('supplierReturnOrder/fetchAll');
        } catch (e) {
        }
        this.buttonLoader = false;
      },
      updateSupplierReturnOrder() {
        this.$router.push('/processes/supplier-return-orders/update/' + this.supplierReturnOrder.id);
      },
      async send() {
        this.buttonLoader = true;
        try {
          await this.$store.dispatch('supplierReturnOrder/send', this.supplierReturnOrder.id);
        } catch (e) {}
        this.$store.dispatch('supplierReturnOrder/fetchAll');
        this.buttonLoader = false;
      },
      openDeleteConfirmation() {
        this.$confirm('Ez a folyamat nem visszafordítható és a kapcsolódó elemek is törölve lesznek.', 'Biztosan törölni szeretnéd?', {
          confirmButtonText: 'Igen',
          cancelButtonText: 'Mégse',
          type: 'warning',
        })
        .then(() => {
          this.deleteSupplierReturnOrder();
        })
        .catch(() => {
          this.$router.replace('/processes/supplier-return-orders');
        });
      },
      handleAction(action) {
        action();
      },
      toggleDropDown() {
        this.$refs['dropDown'].visible = !this.$refs['dropDown'].visible;
      },
      async copySupplierReturnOrder() {
        this.$router.push('/processes/supplier-return-orders/add/' + this.supplierReturnOrder.id);
      },
      async exportExcel() {
        try {
          this.buttonLoader = true;
          const excel = await axios({
            url: 'api/supplier-return-orders/' + this.supplierReturnOrder.id + '/export',
            method: 'GET',
            responseType: 'blob',
          });
          saveAs(excel, 'supplier_return_order_items.xlsx');
        } catch (e) {
        }
        this.buttonLoader = false;
      },
    }
  };
</script>
